import { LoggerWarning } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class LoggerSilentRaiseWarning extends LoggerWarning {
  static override locales: Locales = {
    'en-US':
      'The current application has some errors that can be resolved, ' +
      'switch to development mode to view the detailed error information',
    'zh-CN':
      '当前应用存在一些可以被解决的错误，切换到开发模式以查看详细错误信息',
    'zh-HK':
      '當前應用存在一些可以被解決的錯誤，切換到開發模式以查看詳細錯誤信息'
  }

  override name = 'LoggerSilentRaiseWarning' as const

  constructor() {
    super()
  }
}
